export default __webpack_public_path__ + "static/media/teaching_icon.6eb93059.png";